export default __webpack_public_path__ + "static/media/6.7dadd007.gif";